<!-- 
    <componentTooltip :text="'Mon message'" :position="'right'">
        <div class="test">
            <p>je suis la pour un simple test</p><br>
        </div>
        <button>test moi !</button>
    </componentTooltip> 

    position : Position de la Tooltip
        Default value : top
        Other value : left, right or bottom

    text : contenue de la Tooltip
        value : custom
-->

<template>
    <div ref="divHasTooltip" :class="`${active ? 'enable' : 'disable'} ${classCustom}`" class="hasTooltip" @mouseover="showToolTip($event)" @mouseleave="hideToolTip" @click="handlerClick">
        <slot></slot>
    </div>
</template>

<script>
import store from './../../../store/index.js';

export default {
    props: {
        text: String,
        position: String,
        // key: Number,
        active: {
            default: true,
            type: Boolean
        },

        classCustom: {
            type: String,
            default: ''
        },

        condition: {
            type: Function,
            //params => (divHasTooltip)
            default() {
                return true
            }
            
        }
    },

    data() {
        return {
            display: false
        }
    },

    computed: {
        // tooltipDisplay() {
        //     return this.$store.getters['tooltip/tooltipDisplay'];
        // }
    },

    methods: {
        showToolTip(event) {
            if(this.active && this.condition(this.$refs.divHasTooltip)) {
                this.$store.commit('tooltip/updateTooltipContent', this.text);
                this.$store.commit('tooltip/updateTooltipPosition', this.position || "");
                this.$store.commit('tooltip/updateTooltipElementTarget', event.currentTarget);
                this.$store.commit('tooltip/updateTooltipDisplay', true);
                this.display = true;
            }
        },
        hideToolTip() {
            this.$store.commit('tooltip/updateTooltipDisplay', false);
            this.$store.commit('tooltip/updateTooltipElementTarget', null);
            this.display = false;
        },

        handlerClick(e) {
            this.$emit('click',e)
        } 

    },

    beforeDestroy() {
        if (this.display) this.hideToolTip();
    },
}

</script>



